<template>
  <div class="about wrap">
    <SlotPageVisual>
      <template #visual-bg>
        <div class="img about"></div>
      </template>
      <template #contents>
        <HalfPageLayout>
          <template #half-left></template>
          <template #half-right>
            <div class="inner-contents about-main">
              <h3 class="visual-title"  data-aos="fade-up" data-aos-delay="700" >
                {{ $t('about.mainText') }}
              </h3>
              <p class="visual-summary" data-aos="fade-up" data-aos-delay="1000" >
                {{ $t('about.mainDesc.01') }}
              </p>
              <p class="visual-summary" data-aos="fade-up" data-aos-delay="1500" >
                {{ $t('about.mainDesc.02') }}
              </p>
              <p class="visual-summary" data-aos="fade-up" data-aos-delay="2000" >
                {{ $t('about.mainDesc.03') }}
              </p>
            </div>
          </template>
        </HalfPageLayout>
      </template>
    </SlotPageVisual>
  </div>
</template>
<script>
import SlotPageVisual from '@/components/SlotPageVisual'
import HalfPageLayout from '@/components/HalfPageLayout'

export default {
  name: 'aboutView',
  components: {
    SlotPageVisual,
    HalfPageLayout
  }
}
</script>
